<template>
  <div id="ranking_user">
    <van-row>
      <van-col span="24" :class="ranking_active ==='rich' ? 'ranking_user_top_bg' : 'ranking_user_top_bg2'">
        <van-col span="24">
          <van-nav-bar
            left-arrow
            placeholder
            safe-area-inset-top
            class="ranking_user_top_bg_bar"
            @click-left="onClickLeft"
          >
          <template #title>
            <van-tabs v-model="ranking_active" @click="onClickRankingActive" line-width="20px" title-active-color="#ffffff" title-inactive-color="#9B9CBF">
              <van-tab :title="$t('column.rich_list')" name="rich"/>
              <van-tab :title="$t('column.charm_list')" name="charm"/>
            </van-tabs>
          </template>
          </van-nav-bar>
        </van-col>
        <van-col span="22" offset="1" :class="ranking_active ==='rich' ? 'ranking_user_top_day ranking_user_top_day1' : 'ranking_user_top_day ranking_user_top_day2'">
          <van-tabs type="card" v-model="day_active" @click="onClickRankingDay">
            <van-tab :title="$t('column.day_list')" name="day"></van-tab>
            <van-tab :title="$t('column.Monthly_list')" name="month"></van-tab>
            <van-tab :title="$t('column.all_list')" name="all"></van-tab>
          </van-tabs>
        </van-col>
        <van-col span="22" offset="1">
          <van-col span="7" class="ranking_user_number">
            <van-col span="22" offset="1" class="ranking_user_number_bg2 ranking_user_number_bg" @click="JumpUserinfo(list.length > 1 ? list[1].user_id : 0)">
              <img src="../assets/img/rank/rank2.png" class="ranking_user_number_img2"/>
              <van-image
                width="12vw"
                height="12vw"
                round
                class="ranking_user_number_avatar"
                fit="cover"
                :src="list[1].head_image"
                v-if="list.length > 1"
              />
              <van-col span="22" offset="1" class="ranking_user_number_name"> {{ list.length > 1 ? list[1].nick_name : '' }} </van-col>

              <van-col span="22" offset="1" class="ranking_user_number_coin">{{ list.length > 1 ? list[1].ticket : '' }}</van-col>
              <van-col span="22" offset="1" class="ranking_user_number_coin_name"> {{ unit }}  </van-col>
            </van-col>
          </van-col>
          <van-col span="10" class="ranking_user_number">
            <van-col span="20" offset="2" class="ranking_user_number_bg1 ranking_user_number_bg" @click="JumpUserinfo(list.length > 0 ? list[0].user_id : 0)">
              <img src="../assets/img/rank/rank1.png" class="ranking_user_number_img"/>
              <van-image
                width="12vw"
                height="12vw"
                round
                class="ranking_user_number_avatar"
                fit="cover"
                :src="list[0].head_image"
                v-if="list.length > 0"
              />
              <van-col span="22" offset="1" class="ranking_user_number_name">{{ list.length > 0 ? list[0].nick_name : '' }} </van-col>

              <van-col span="22" offset="1" class="ranking_user_number_coin"> {{ list.length > 0 ? list[0].ticket : '' }} </van-col>
              <van-col span="22" offset="1" class="ranking_user_number_coin_name"> {{ unit }}  </van-col>
            </van-col>
          </van-col>
          <van-col span="7" class="ranking_user_number">
            <van-col span="22" offset="1" class="ranking_user_number_bg3 ranking_user_number_bg" @click="JumpUserinfo(list.length > 2 ? list[2].user_id : 0)">
              <img src="../assets/img/rank/rank3.png" class="ranking_user_number_img2"/>
              <van-image
                width="12vw"
                height="12vw"
                round
                class="ranking_user_number_avatar"
                fit="cover"
                :src="list[2].head_image"
                v-if="list.length > 2"
              />
              <van-col span="22" offset="1" class="ranking_user_number_name">{{ list.length > 2 ? list[2].nick_name : '' }} </van-col>

              <van-col span="22" offset="1" class="ranking_user_number_coin">  {{ list.length > 2 ? list[2].ticket : '' }}  </van-col>
              <van-col span="22" offset="1" class="ranking_user_number_coin_name"> {{ unit }} </van-col>
            </van-col>
          </van-col>
        </van-col>

      </van-col>
      <van-col span="24" class="ranking_user_list">
        <van-list
        >
          <van-cell v-for="(item,i) in list" :key="i" v-if="i > 2">
            <van-col span="24" class="ranking_user_list_item">
              <van-col span="3" offset="1" class="ranking_user_list_item_number">{{ i + 1 }}</van-col>
              <van-col span="4" class="ranking_user_list_item_avatar">
                <van-image
                  width="10vw"
                  height="10vw"
                  round
                  :src="item.head_image"
                  fit="cover"
                  @click="JumpUserinfo(item.user_id)"
                />
                <div :id='"popular_svga"+item.user_id' class="ranking_user_list_item_avata_frame" @click="JumpUserinfo(item.user_id)" v-if="item.avatar_frame_url"></div>
              </van-col>
              <van-col span="9" class="ranking_user_list_item_user">
                <van-col span="24" class="ranking_user_list_item_user_name">{{ item.nick_name }}</van-col>
                <van-col span="24" class="ranking_user_list_item_user_level">

                  <img :src="item.user_level_url" class="ranking_user_list_item_user_level_name"/>
                </van-col>
              </van-col>
              <van-col span="6" class="ranking_user_list_item_coin">{{ item.ticket }}</van-col>
            </van-col>
          </van-cell>
        </van-list>
      </van-col>
      <van-overlay :show="overlayShow" z-index="3">
        <van-loading type="spinner" class="loading_overlay"/>
      </van-overlay>
    </van-row>
  </div>
</template>

<script>

import '@/assets/css/style.css'
import axios from "axios";
import {Toast} from "vant";
import SVGA from "svgaplayerweb";

export default {
  data() {
    return {
      day_active: 'day',
      ranking_active: 'rich',
      list: [],
      overlayShow: false,
      finished: false,
      unit: ''
    }
  },
  mounted() {
    document.title = this.$t('column.ranking')
    // 优先从缓存中恢复数据
    const cachedData = localStorage.getItem('rankingUser');
    if (cachedData) {
      this.day_active=localStorage.getItem('rankingUserDayActive');
      this.ranking_active=localStorage.getItem('rankingUserRankingActive');
      this.list = JSON.parse(cachedData);
      localStorage.removeItem('rankingUser');
      localStorage.removeItem('rankingUserDayActive');
      localStorage.removeItem('rankingUserRankingActive');
      console.log('数据已从缓存中恢复');
    } else {
      this.convert(); // 如果没有缓存数据，则从服务器加载
    }
  },
  // created: function () {
  //   this.convert()
  //   document.title = this.$t('column.ranking')
  // },
  methods: {
    onClickRankingActive(name, title) {
      this.ranking_active = name
      this.convert()
    },
    onClickRankingDay(name, title) {
      this.day_active = name
      this.convert()
    },
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogogame://exit"
    },
    JumpUserinfo(id) {
      console.log(id)
      if(id){
        localStorage.setItem('rankingUser', JSON.stringify(this.list)); // 缓存当前数据
        localStorage.setItem('rankingUserDayActive', this.day_active); // 缓存当前数据
        localStorage.setItem('rankingUserRankingActive', this.ranking_active); // 缓存当前数据
        // 拦截跳转用户主页面
        window.location.href="live://live?action=JumpUser&id=" + id
      }
    },
    SVGA() {
      this.$nextTick(()=>{
        this.list.map((v,i)=>{
          if (v.avatar_frame_url && i > 2) {
            //这里动态给ID，列表
            var player = new SVGA.Player('#popular_svga'+v.user_id);
            var parser = new SVGA.Parser('#popular_svga'+v.user_id);
            //这里使用动态加载的方式，加载tableData返回的svga源（例如：http://a.svga)
            console.log('svga======')
            console.log(v.avatar_frame_url)
            parser.load(v.avatar_frame_url, function(videoItem) {
              player.setVideoItem(videoItem);
              player.startAnimation();
            })
          }
        })
      })
    },
    convert() {
      this.overlayShow = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=rank&act=charm_rich_rank", {
        params : {
          token: token,
          rank_type: this.ranking_active,
          rank_name: this.day_active,
        }
      }).then(res =>{
        this.overlayShow = false
        if (res.data.status === 0) {
          Toast(res.data.error)
          return false
        }
        this.unit = res.data.data.unit
        this.list = []
        for(let i = 0; i< res.data.data.list.length; i ++) {
          res.data.data.list[i]['user_level_url'] =  require('../assets/img/rank_'+res.data.data.list[i].user_level+'.png')
          this.list.push(res.data.data.list[i])
        }
        this.SVGA()
        this.finished = true
      })
    }
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ranking_user.vue